export class WizardPreviewRequest{
    public base64InputFile!:string;
    public definitionList:DefinitionObject[]=[]

    contructor(){
    }
}

export class DefinitionObject{
    public type!:string;
    public sequenceNo!:number;
    public definitionDTO!: any;
}